import type {
    ApplicationModule,
    ApplicationModuleCode,
    ApplicationModuleId
} from '@/domain/application-modules/application-module.interface';
import { CoreApiVersionPath, RosaCoreApiService } from '@/rosa';
import { Injectable, inject } from '@angular/core';
import type { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import type { ProjectId } from '../../interfaces/Project.interface';

interface CoreApplicationModule {
    projectId: ProjectId;
    appModuleId: ApplicationModuleId;
    appModuleCode: ApplicationModuleCode;
    appModuleType: string;
    isOpenToPublic: boolean;
    isOpenToInternal: boolean;
}

@Injectable({
    providedIn: 'root'
})
export class AdvizeoCoreApplicationModulesProvider {
    private _rosaCoreApiService = inject(RosaCoreApiService);

    fetchApplicationModules$(projectId: string): Observable<ApplicationModule[]> {
        return this._rosaCoreApiService.get(`${CoreApiVersionPath.V3}projects/${projectId}/application-modules`).pipe(
            map(coreApplicationModules => {
                const applicationModules = (coreApplicationModules as CoreApplicationModule[]).map(coreApplicationModule =>
                    this.mapCoreApplicationModuleToApplicationModule(coreApplicationModule)
                );
                return applicationModules;
            })
        );
    }

    private mapCoreApplicationModuleToApplicationModule(coreApplicationModule: CoreApplicationModule): ApplicationModule {
        const applicationModule: ApplicationModule = {
            applicationModuleId: coreApplicationModule.appModuleId,
            code: coreApplicationModule.appModuleCode,
            type: coreApplicationModule.appModuleType,
            isOpenToPublic: coreApplicationModule.isOpenToPublic,
            isOpenToInternal: coreApplicationModule.isOpenToInternal
        };
        return applicationModule;
    }
}
